export default __webpack_public_path__ + "static/media/office-chat.1320f274.jpg";